<template>
	<el-table
			v-if="!loading &&tableData.length > 0"
			height="100%"
			:data="tableData"
			style="width: 100%">
		<el-table-column
				prop="name"
				label="名称"
		>
		</el-table-column>
		<el-table-column
				v-for="(item, index) in titles"
				:key="index"
				:prop="item"
				:label="item">
				<!-- <template slot-scope="scope">
                    <span>{{scope.row[item].toFixed(2)}}kWh</span>
                </template> -->
		</el-table-column>
	</el-table>
	<div v-else class="row-center tip">
		<img v-if="loading" src="../../../assets/img/loading.png" class="loading">
		<img v-else src="../../../assets/img/not_found_data.png" alt="">
	</div>
</template>

<script>
	import {floatFormat} from "../../../util/MathUtil"
	import {currentDay, monthDays,weekStart,weekEnd,dateFormat} from "../../../util/DateUtil";
	import {BuildingItemEnergy} from "../../../api/power";
	import exportExcel from "../../../util/excel";
	import Axios from "axios"
	import dict from "../../../util/dict"
	import ExcelJS from 'exceljs'
	import FileSaver from 'file-saver'
	export default {
		props: {
			loops: Array,
			range: String,
			date: Date
		},
		name: "Running",
		data() {
			return {
				loading:false,
				titles:["空调","照明","动力","特殊"],
				tableData:[],
				timeDate:""
			}
		},
		mounted() {
			this.requestData();
		},
		computed: {
			dateName(){
				switch (this.range) {
					case 'day':
						this.timeDate = dateFormat("YY-mm-dd", this.date)
						return "日"
						break;
					case 'week':
						this.timeDate = dateFormat("YY-mm-dd", this.date)
						return "周"
						break;
					case 'month':
						this.timeDate = dateFormat("YY-mm", this.date)
						return "月"
						break;
					case 'year':
						this.timeDate = dateFormat("YY", this.date)
						return "年"
						break;
					default:
						this.timeDate = dateFormat("YY-mm-dd", this.date)
						return "日"
						break;
				}
			},
			selProjectName() {
				return this.$store.getters.selProjectInfo.projectName;
			},
			propsData(){
				return [
					this.date,
					this.range,
					this.loops,
					this.node
				]
			},
			diagramStatus(){
				return this.$store.state.project.diagramStatus
			},
		},
		methods: {
			//数据
			async requestData(){
				this.loading = true;
				let range = this.range;
				let promises = [];
				let currList = this.loops;
				currList.forEach((element) => {
					let obj = {
					buildingId: element.id,
					date: dateFormat("YY-mm-dd", this.date) + "T00:00:00Z",
					itemType: "",
					range: range.toUpperCase(),
					};
					promises.push(BuildingItemEnergy(obj));
				});
				let list = []
				Promise.all(promises).then((res) => {
					let pointsArray = res.map((r) =>
					r.data.data.result ? r.data.data.result : {}
					);
					pointsArray.forEach((item, index) => {
						let newdata = {}
						for(let i in item){
							newdata[i] = item[i].toFixed(2)+' kWh'
						}
						newdata.name = this.loops[index].name;
						list.push(newdata)
					});
					this.loading = false
					this.tableData = list
				});
			},
		},
		watch: {
			propsData(){
				this.requestData();
			},
			diagramStatus(n){
				if(this.$route.query.uid=== 'Suboption' ){
					if(n.type === 'excel' && this.tableData.length > 0){
						let data = [
							['名称']
						]
						this.titles.forEach(t => {
							data[0].push(t)
						})
						this.tableData.forEach(d => {
							data.push([d.name, ...this.titles.map(t => d[t])])
						})
						// exportExcel(data, '分项能耗报表', [])
						const workbook = new ExcelJS.Workbook();
						// 创建带有红色标签颜色的工作表
						const sheet = workbook.addWorksheet('Sheet1');

						let letter = ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z','AA','AB','AC','AD','AE','AF','AG','AH','AI']
							letter = letter.filter((e,i)=>i<4)
						let sheetName = ["分项能耗"+this.dateName+"报表",this.selProjectName,'日期：'+this.timeDate]
						let style =  {
							fill: {
								type: 'gradient',
								gradient: 'angle',
								degree: 0,
								stops: [
								{ position: 0, color: { argb: 'd9d9d9' } },//单元格渐变色（左） 
								{ position: 0.5, color: { argb: 'd9d9d9' } },//单元格渐变色（中）
								{ position: 1, color: { argb: 'd9d9d9' } }//单元格渐变色（右）
								]
							},
							font20:{
								name: 'Arial',
								size: 20,
								bold: true
							},
							font12bold:{
								name: 'Arial',
								size: 12,
								bold: true
							},
							font12:{
								name: 'Arial',
								size: 12,
								// bold: true
							},
							alignmentCenter:{ vertical: 'middle', horizontal: 'center' },
							alignmentLeft:{ vertical: 'middle', horizontal: 'left' },
							border:{
								top: {style:'thin'},
								left: {style:'thin'},
								bottom: {style:'thin'},
								right: {style:'thin'}
							}
						}

						//处理一二层
            
						sheet.mergeCells(letter[0]+'1:'+letter[letter.length-1]+'1');
						sheet.getCell(letter[0]+'1').value = sheetName[0]
						sheet.getCell(letter[0]+'1').font = style.font20
						sheet.getCell(letter[0]+'1').alignment = style.alignmentCenter
						
						sheet.mergeCells('A2:B2');
						sheet.mergeCells('C2:'+letter[letter.length-1]+'2');
						sheet.getCell('A2').value = sheetName[1]
						sheet.getCell('C2').value = sheetName[2]
						sheet.getRow(2).font=style.font12bold
						sheet.getRow(2).alignment = style.alignmentLeft
						const rows = sheet.getRows(1, 2);
						rows.map(e=>{e.height = 50 ;return e})

						//表格设置
						let columns = []
						data[0].forEach(item=>{
							columns.push({
								name:item,
							})
						})
						sheet.addTable({
							name: 'MyTable',
							ref: 'A3', // 表格左上角的位置
							headerRow: true,
							totalsRow: false,
							style: {
								theme: 'TableStyleLight1',
								font:{
									name: 'Arial',
									size: 12,
									// bold: true
								},
							},
								//            showRowStripes: true,
							columns:columns,
							rows: data.slice(1),
						})

						//表格头部样式
						sheet.getRow(3).height = 59
						sheet.getRow(3).font=style.font12bold
						
						letter.forEach(item=>{
							sheet.getCell(item+'3').fill = style.fill
							sheet.getCell(item+'3').border = style.border
							sheet.getRow(3).alignment = style.alignmentCenter
						})
						data.slice(1).forEach((item,index)=>{
							sheet.getRow(4+index).height = 38
							sheet.getRow(4+index).font=style.font12
							letter.forEach((e,i)=>{
								sheet.getColumn(e).width = 40
								sheet.getCell(e+(4+index)).border = style.border
							})
						
							sheet.getRow(4+index).alignment = style.alignmentCenter
						})
						

						// workbook.xlsx.writeFile('test.xlsx')
						workbook.xlsx.writeBuffer().then(buffer => {
							FileSaver.saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${sheetName[0]}.xlsx`);
						})
					}else {
						this.$message.warning("无图表数据！")
					}
				}
			},
		}
	}
</script>

<style scoped lang="less">
	.tip {
		width: 100%;
		height: 100%;
		font-size: 16rem;
		color: #8c939d;
	}

	.loading {
		width: 28rem;
		height: 28rem;
		animation: loading 1s linear infinite;
	}

	@keyframes loading {
		0% {
			transform: rotate(0);
		}
		100% {
			transform: rotate(360deg);
		}
	}
</style>